import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { Text } from '@oneaudi/unified-web-components';
import { ListItemContainer, ItemContainer, InfoItemsContainer, } from './styles/CarinfoWrapper.styles';
import { StyledInfoText } from './styles/InfoItemsWrapper.styles';
export const InfoItemsWrapper = ({ vehicleBasic }) => {
    const commissionLabel = useI18n({
        id: 'nemo.ui.sc.details.commision-number',
        defaultMessage: 'Order Nummer:',
    });
    const listToBeRendered = [
        {
            key: commissionLabel,
            value: vehicleBasic.commissionNumber,
        },
    ];
    return (React.createElement(InfoItemsContainer, null, listToBeRendered.map((item) => {
        if (!item.value) {
            return null;
        }
        return (React.createElement(ListItemContainer, { key: item.key },
            React.createElement(ItemContainer, null,
                React.createElement(Text, { tag: "span", variant: { order: '2', style: 'normal' } }, item.key),
                React.createElement(StyledInfoText, { tag: "span", variant: { order: '2', style: 'normal' } }, item.value))));
    })));
};
